import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../api/api.service';
import {NOTIFICATIONS_ENDPOINTS} from "../../api/endpoints/notifications.endpoints";

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private api = inject(ApiService);

  // shared notifiaction
  sendPrivateNotification(data, params): Observable<any> {
    return this.api.post(NOTIFICATIONS_ENDPOINTS.V1.SEND_PRIVATE_NOTIFICATION, data, {params: params}).pipe(
      map(res => {
        return res
      })
    )
  }
// shared
  getTestedNotificationList() {
    return {
      links: {
        next: null,
        previous: null
      },
      count: 15,
      pages_count: 1,
      results: [
        {
          id: 86,
          notification_type: "الإدارة, الفاحص, العميل",
          title: null,
          body: "test",
          url: null,
          date_added: "2021/11/14"
        },
        {
          id: 88,
          notification_type: "الإدارة, الفاحص, العميل",
          title: null,
          body: "test",
          url: null,
          date_added: "2021/11/14"
        },
        {
          id: 89,
          notification_type: "الإدارة, الفاحص, العميل",
          title: null,
          body: "test",
          url: null,
          date_added: "2021/11/14"
        }
      ]
    };
  }
}
